import { render, staticRenderFns } from "./DashboardEcommerce.vue?vue&type=template&id=6932eeee&"
import script from "./DashboardEcommerce.vue?vue&type=script&lang=js&"
export * from "./DashboardEcommerce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports